// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__S4qfZ","info":"Note_info__2rL8v","note":"Note_note__2duZ8","actions":"Note_actions__3GEfx"};